module.exports = __webpack_public_path__ + "static/media/121.f2214312.png";